import { useState } from "react";
import { Loader2, CheckCircle2 } from "lucide-react";
import { joinWaitlist } from "../lib/api";

export const WaitlistForm = ({ dark = false }) => {
  const [email, setEmail] = useState("");
  const [state, setState] = useState("idle"); // idle | loading | done
  const [msg, setMsg] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    if (state === "loading") return;
    setState("loading");
    try {
      const res = await joinWaitlist(email);
      setMsg(res.message);
      setState("done");
    } catch (err) {
      setMsg(err?.response?.data?.detail || "Something went wrong. Please try again.");
      setState("idle");
    }
  };

  if (state === "done") {
    return (
      <div data-testid="waitlist-success" className="flex items-center justify-center gap-2 text-sm font-medium text-emerald-700">
        <CheckCircle2 className="h-5 w-5" /> {msg}
      </div>
    );
  }

  return (
    <form onSubmit={submit} className="flex w-full max-w-md flex-col gap-2 sm:flex-row" data-testid="waitlist-form">
      <input
        type="email"
        required
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="you@example.com"
        data-testid="waitlist-email-input"
        className={`flex-1 rounded-full border px-5 py-3 text-sm outline-none transition-colors focus:border-neutral-900 ${
          dark ? "border-neutral-700 bg-neutral-900 text-white placeholder:text-neutral-500" : "border-[#e8e6df] bg-white text-neutral-900"
        }`}
      />
      <button
        type="submit"
        disabled={state === "loading"}
        data-testid="waitlist-submit-btn"
        className="inline-flex items-center justify-center gap-2 rounded-full bg-[#E24B4A] px-6 py-3 text-sm font-semibold text-white transition-transform active:scale-95 hover:opacity-90 disabled:opacity-60"
      >
        {state === "loading" ? <Loader2 className="h-4 w-4 animate-spin" /> : null}
        Request early access
      </button>
    </form>
  );
};

export default WaitlistForm;
